import { render, staticRenderFns } from "./IdentityManage.vue?vue&type=template&id=22f45f54&scoped=true"
import script from "./IdentityManage.vue?vue&type=script&lang=js"
export * from "./IdentityManage.vue?vue&type=script&lang=js"
import style0 from "./IdentityManage.vue?vue&type=style&index=0&id=22f45f54&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f45f54",
  null
  
)

export default component.exports